

export default function Footer() {
  return (
    <div className="footer">
      <footer id="sticky-footer" className="flex-shrink-0 py-4 bg-dark text-white-50">
      <div className="container text-center">
        <small>&copy; Designed and Built by Chrysalis Woon</small>
      </div>
    </footer>
    </div>
  );
}
